"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useGuidedSellingStatus = require("../../hooks/app/useGuidedSellingStatus");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useAppSelector = require("../../hooks/useAppSelector");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledCloseButton = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  ${props => props.showWhiteBackground && (0, _styledComponents.css)`
      & svg {
        transform: scale(0.7);
        background-color: #ffffff;
        color: #000000;
        stroke: #000000 !important;
        border-radius: 5px;
      }
    `}
`;
const HeaderTop = _ref => {
  let {
    actionComponent,
    isCloseButtonHidden,
    headerText,
    headerSubText,
    showDivider,
    id = ''
  } = _ref;
  const {
    closeGuidedSellingModal
  } = (0, _useGuidedSellingStatus.useGuidedSellingStatus)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const adustCloseBtn = (0, _useLocalTheme.default)('header.adustCloseBtn', false);
  const spacingLevel = (0, _useLocalTheme.default)('recommendation.spacingLevel', 1);
  const showWhiteBackGround = (0, _useLocalTheme.default)('showWhiteBackGround', false);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: spacingLevel
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, headerText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: headerText,
    size: 3,
    weight: 1,
    justify: "center"
  }), headerSubText && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: headerSubText,
    size: 1,
    weight: 2,
    justify: "center"
  })), actionComponent && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'left',
    verticalAlign: 'stretch'
  }, actionComponent)), showModalView && !isCloseButtonHidden && /*#__PURE__*/_react.default.createElement(StyledCloseButton, {
    showWhiteBackground: showWhiteBackGround
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'right',
    verticalAlign: 'stretch'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    dataAttributes: {
      'data-test-id': 'overlay-button-close'
    },
    srText: "Close",
    name: "close",
    size: adustCloseBtn ? 5 : 4,
    appearance: "primary",
    onClick: closeGuidedSellingModal
  }))))), showDivider && !adustCloseBtn && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    noMargin: true
  }));
};
var _default = HeaderTop;
exports.default = _default;